export var TooltipSkin;
(function (TooltipSkin) {
    TooltipSkin["Standard"] = "standard";
    TooltipSkin["Error"] = "error";
    TooltipSkin["Wired"] = "wired";
})(TooltipSkin || (TooltipSkin = {}));
//# sourceMappingURL=types.js.map